<script lang="ts">
	import type { Snippet } from "svelte";
	import type { ClassValue, HTMLAttributes, HTMLInputAttributes, HTMLLabelAttributes } from "svelte/elements";

	const {
		horizontal,
		label,
		required,
		content,
		wrapperClass,
		error = "",
		...rest
	}: HTMLAttributes<HTMLDivElement> & {
		wrapperClass?: ClassValue;
		required?: HTMLInputAttributes["required"];
		horizontal?: boolean;
		label?: HTMLLabelAttributes;
		content: Snippet;
		error?: string;
	} = $props();
</script>

<div class={["flex text-left gap-2", horizontal ? "flex-row items-center" : "flex-col", wrapperClass]}>
	{#if horizontal}
		{@render content()}
	{/if}
	<label class={["text-midnight/80 text-sm font-medium", horizontal && "flex-1"]} {...label}>
		{@render rest.children?.()}
		{#if required}
			<span class="text-copper-300">*</span>
		{/if}
	</label>
	{#if !horizontal}
		{@render content()}
	{/if}
	{#if error}
		<p class="text-copper-300 text-xs w-full">{error}</p>
	{/if}
</div>
